var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9181 6.45505C16.8445 6.44309 16.7699 6.43758 16.6953 6.43855H3.9967L4.2736 6.30976C4.54425 6.18165 4.79048 6.0073 5.00125 5.7946L8.56227 2.23358C9.03127 1.78588 9.11007 1.06566 8.74902 0.527125C8.3288 -0.0467513 7.52295 -0.171355 6.94903 0.24886C6.90266 0.282828 6.85859 0.319855 6.81718 0.359699L0.377725 6.79916C-0.125519 7.30184 -0.125962 8.11727 0.376718 8.62052C0.37704 8.62084 0.377403 8.6212 0.377725 8.62152L6.81718 15.061C7.32083 15.5632 8.13626 15.5621 8.63854 15.0584C8.67806 15.0188 8.71497 14.9766 8.74902 14.9322C9.11007 14.3937 9.03127 13.6734 8.56227 13.2257L5.00769 9.65827C4.81874 9.46912 4.60148 9.3105 4.36375 9.18819L3.97738 9.01433H16.6245C17.2824 9.03876 17.8596 8.57918 17.9832 7.9325C18.0971 7.2304 17.6202 6.56895 16.9181 6.45505Z",
    fill: "#FEFEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.1d8e20947f5278771e13171604722abb.svg";
export { ForwardRef as ReactComponent };